import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const ArrowDownComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__arrowDown"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path d="M8 3.33337V12.6667" stroke={colorVar} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M12.6667 8L8.00004 12.6667L3.33337 8"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowDown = withIcon(ArrowDownComponent);
